import React, {useRef} from 'react';
import {AiFillCloseCircle} from 'react-icons/ai';
import { Link } from 'react-router-dom'
import { useStateContext } from '../context/StateContext';
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';
import { isGodMode, isMindPro } from '../utils/permissions';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import T from '../components/Translation';
import { useDocumentsContext } from '../hooks/useDocumentsContext';
import AuthNav from '../whitaijiFrontendLibrary/auth/components/AuthNav';
import useMediaQuery from '../hooks/useMediaQuery';
import Divider from '../whitaijiFrontendLibrary/components/Divider';
import { goldColour } from '../pages/Home';

const Sidebar = () => {
   const screenSizeNotMobile = useMediaQuery("(min-width: 742px)")
    const {setShowSidebar} = useStateContext();
    const { user } = useAuthContext(AuthContext)
    const sidebarRef = useRef();
    const { dispatch: dispatchdocuments } = useDocumentsContext()
    const resetContextFn = () => {
      dispatchdocuments({ type: 'SET_DOCUMENTS', payload: null })   
    }


    return (

        <div className="cart-wrapper" ref={sidebarRef}>
            <div className="sidebar-container">
                <div className='top-sidebar-container'>
                  <Link style={{marginLeft:"15px"}} onClick={() => setShowSidebar(false)} to="/">
                    <img src="/reMindLogo.png" alt="reMind Logo" style={{ height: '80px' }} />
                  </Link>
                  <button type="button" className="sidebar-close-button" onClick={() => setShowSidebar(false)}>
                      <AiFillCloseCircle/>
                  </button>
                </div>
                <div className='body-sidebar-container'>
                { !screenSizeNotMobile &&
                <AuthNav AuthContext={AuthContext} resetContextFn={resetContextFn}/>}
                  <VisDiv rules={[false]} className={"sidebar-title"}>
                    <h3> TITOLO IN SIDEBAR</h3>
                  </VisDiv>
                  <Divider/>
                  <VisDiv style={{display:"flex", justifyContent:"center", alignItems:"center"}} rules={[true]} className={"sidebar-title"}>
                    <h3> MY </h3>
                    <h2 style={{marginLeft:"5px", paddingBottom:"4px", color:goldColour}}> reMind</h2>
                  </VisDiv>
                  <SidebarItem to="/" title = {"MY DASHBOARD"} hide={!user}/>
                  <SidebarItem to="/login" title = {"MY DASHBOARD"} hide={user}/>
                  <SidebarItem to="/my-journal" title={<T obj={{ en: 'MY JOURNAL', it: 'IL MIO DIARIO'}}/>}/>
                  {/* <Divider height={"40px"}/> */}
                  <SidebarItem to="/" hide={user} title={"HOME"}/>
                  <VisDiv rules={[isGodMode(user)]} className={"sidebar-title"}>
                    <h3> <T obj={{en:"MARKETING", it:"MARKETING"}}/></h3>
                  </VisDiv>
                  <SidebarItem to="/crm" title = {"CRM"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/create-campaign" title = {"CAMPAIGNS"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/build-survey" title = {"SURVEYS"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/emails" title = {"SEND EMAIL"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/invite-client" title = {"INVITE CLIENT"} hide={!isGodMode(user) && !isMindPro(user)}/>
                  <VisDiv rules={[isGodMode(user)]} className={"sidebar-title"}>
                    <h3> <T obj={{en:"MANAGEMENT", it:"MANAGEMENT"}}/></h3>                    
                  </VisDiv>
                  <SidebarItem to="/manage-songs" title = {"SONGS"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/signup_user" title = {"USER SIGN-UP"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/doctest" title = {"DOC TEST"} hide={true}/>

                  <VisDiv rules={[isGodMode(user)]} className={"sidebar-title"}>
                    <h3> <T obj={{en:"REPORTS", it:"REPORTS"}}/></h3>
                  </VisDiv>
                  <SidebarItem to="/logs-report" title = {"SONG LOGS"} hide={!isGodMode(user)}/>
                  <VisDiv rules={[true]} className={"sidebar-title"}>
                    <h3> <T obj={{en:"WEBSITE", it:"WEBSITE"}}/></h3>
                  </VisDiv>
                  <SidebarItem to="/home" title = {"HOME PAGE"} hide={!user}/>
                  <SidebarItem to="/about" title={<T obj={{it: "CHI SONO", en: "MORE ABOUT MICHAEL"}}/>}/>
                  <SidebarItem to="/how-it-works" title={<T obj={{it: "COME FUNZIONA", en: "HOW DOES IT WORK"}}/>}></SidebarItem>
                  <SidebarItem to="/tell-me-how-you-feel"  hide={!isGodMode(user)} title={<T obj={{ en: 'TELL ME HOW YOU FEEL', it: 'RACCONTAMI COME TI SENTI'}}/>}/>


                 
                  {/* <SidebarItem to="/profile" title={<T obj={{it: "IL MIO PROFILO", en: "MY PROFILE"}}/>} hide={!user}/> */}
                 {/*  <SidebarItem to="/make-concert" title = {"MAKE CONCERT"} hide={!isGodMode(user)}/> */}
                  <VisDiv rules={[isGodMode(user)]} className={"sidebar-title"}>
                    <h3> <T obj={{en:"TOOLS", it:"TOOLS"}}/></h3>
                  </VisDiv>
                  <SidebarItem to="/aibot" title = {"AI BOT"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/book-writing" title = {"BOOK WRITING"} hide={!isGodMode(user)}/>
                  <SidebarItem to="/audio-analysis" title = {"AI AUDIO ANALYSIS"} hide={true}/>
                </div>

            </div>
        </div>
    )

}

export default Sidebar

export const SidebarItem = ({to = "/", children, title="", hide=false}) => {
  const {setShowSidebar} = useStateContext();
  if (hide) {return null}
  return (
    <Link onClick={() => setShowSidebar(false)} className={"sidebar-item"} to={to}>
      {title && <h4>{title}</h4>}
      {children}
    </Link> 
  )
}
